import {
  resetFiltersGA,
  selectCountryGA,
  selectOperatorGA,
  selectRegionGA,
  toggleSavedParkGA,
  toggleSavedParksGA,
} from "../analytics";
import {
  resetFilters,
  toggleSavedParksOnlyFilter,
  updateCountryFilter,
  updateOperatorFilter,
  updateRegionFilter,
} from "../Redux/filtersSlice";
import { getSavedParksSelector, toggleSavedPark } from "../Redux/savedParksSlice";
import { parksFilterTealium, parksRemoveAllFiltersTealium } from "../TealiumEvents";

export const analyticsMiddleware = (store) => (next) => (action) => {
  if (!action || !action.type) {
    return next(action);
  }

  const result = next(action);

  switch (action.type) {
    case toggleSavedPark.type: {
      const pid = action.payload;
      const state = store.getState();
      const savedParks = getSavedParksSelector(state);

      const wasSaved = savedParks.includes(pid);
      toggleSavedParkGA(pid, wasSaved);
      break;
    }
    case updateCountryFilter.type: {
      const country = action.payload;
      selectCountryGA(country);
      parksFilterTealium("country", country);
      break;
    }
    case updateRegionFilter.type: {
      const region = action.payload;
      selectRegionGA(region);
      parksFilterTealium("region", region);
      break;
    }
    case updateOperatorFilter.type: {
      const operator = action.payload;
      selectOperatorGA(operator);
      parksFilterTealium("operator", operator);
      break;
    }
    case toggleSavedParksOnlyFilter.type: {
      const isSaved = action.payload;
      toggleSavedParksGA(isSaved);
      break;
    }
    case resetFilters.type: {
      resetFiltersGA();
      parksRemoveAllFiltersTealium();
      break;
    }
    default: {
      break;
    }
  }

  return result;
};
